// extracted by mini-css-extract-plugin
export default {"container":"SubHeader_container__Ob36c","backAction":"SubHeader_backAction__GTRWK","label":"SubHeader_label__gCeCt","subText":"SubHeader_subText__dumZZ"};